import React from 'react';
import { Placeholder } from '../Placeholder/Placeholder';

export const NavbarLeftSectionPlaceholder = () => (
  <Placeholder className="w-8 md:w-[145px] h-8 md:h-10 rounded-[31px]" />
);
